import Immutable from 'immutable';
import { NewMarkup } from 'records/NewMarkup';

export type MarkupId = string;

export interface RawMarkup {
  markupid: MarkupId;
  fileid: string;
  projectid: string;
  jsonBlob: string;
}

export interface MarkupData {
  markupid: MarkupId;
  fileid: string;
  projectid: string;
  jsonBlob: string;
}

const defaultValues: MarkupData = {
  markupid: '',
  fileid: '',
  projectid: '',
  jsonBlob: '',
};

export const MarkupFactory = Immutable.Record(defaultValues, 'Markup');

export class Markup extends MarkupFactory {
  serialize(): RawMarkup {
    return this.toJS();
  }

  static deserialize(rawMarkup: RawMarkup): Markup {
    return new Markup({
      ...rawMarkup,
    });
  }

  intoNewMarkup(): NewMarkup {
    return new NewMarkup({
      ...this.toObject(),
      clientGeneratedID: this.markupid,
    });
  }
}

export type MarkupList = Immutable.List<Markup>;

export type MarkupMap = Immutable.OrderedMap<MarkupId, Markup>;
